import { QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class StatsRest {
  getGeneralFromCourse(
    courseId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/general`;
    return api.get(url, params);
  }

  getQuizFromCourse(courseId: string, params?: QueryParams): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/quizzes`;
    return api.get(url, params);
  }

  getQuizStatsCsv(
    courseId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/quizzes/download`;
    return api.get(url, {}, "/api", "json", 120000);
  }

  getObjectivesFromCourse(
    courseId: string,
    params?: QueryParams
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/learning-objectives`;
    return api.get(url, params, "/graphs");
  }

  getObjectivesStatsCsv(
    courseId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/learning-objectives/download`;
    return api.get(url, {}, "/graphs", "json", 120000);
  }

  getStudentsFromCourse(
    courseId: string,
    params: QueryParams
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/students`;
    return api.get(url, params);
  }

  getStudentsStatsCsv(
    courseId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/students/download`;
    return api.get(url, {}, "/api", "json", 120000);
  }
  getStudentFromCourseById(
    courseId: string,
    studentId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/students/${studentId}/general`;
    return api.get(url, params);
  }
  getQuizStudentFromCourse(
    courseId: string,
    studentId: string,
    params: QueryParams
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/students/${studentId}/quizzes`;
    return api.get(url, params);
  }
  getStudentsQuizStatsCsv(
    courseId: string,
    studentId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/students/${studentId}/quizzes-download`;
    return api.get(url, {}, "/api", "json", 120000);
  }
  getGeneralFromObjective(
    objectiveId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/statistics/learning-objective/${objectiveId}/general`;
    return api.get(url, params);
  }

  getDraftsFeedbacksFromObjective(
    courseId: string,
    objectiveId: string,
    params: QueryParams
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/learning-objectives/${objectiveId}/feedbacks/drafts`;
    return api.get(url, params, "/graphs");
  }

  getDraftsFeedbacksStatsCsv(
    courseId: string,
    objectiveId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/learning-objectives/${objectiveId}/feedbacks/drafts/download`;
    return api.get(url, {}, "/graphs", "json", 120000);
  }
  getQuestionsFromObjectiveStats(
    objectiveId: string,
    params: QueryParams
  ): Observable<any> {
    const url: string = `/statistics/learning-objective/${objectiveId}/questions/quiz`;
    return api.get(url, params, "/api", "json", 120000);
  }

  getChatQuestionsFromObjectiveStats(
    objectiveId: string,
    params: QueryParams
  ): Observable<any> {
    const url: string = `/statistics/learning-objective/${objectiveId}/questions/chat`;
    return api.get(url, params);
  }

  getQuestionsQuizStatsCsv(
    objectiveId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/statistics/learning-objective/${objectiveId}/questions/quiz/download`;
    return api.get(url, {}, "/api", "json", 120000);
  }

  getQuestionsChatStatsCsv(
    objectiveId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/statistics/learning-objective/${objectiveId}/questions/chat/download`;
    return api.get(url, {}, "/api", "json", 120000);
  }

  getMaterialsByObjectiveStats(
    courseId: string,
    objectiveId: string,
    params: QueryParams
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/learning-objectives/${objectiveId}/material-general-statistics`;
    return api.get(url, params, "/graphs");
  }

  getObjectsByObjectiveStatsCsv(
    courseId: string,
    objectiveId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/learning-objectives/${objectiveId}/material-general-statistics/download`;
    return api.get(url, {}, "/graphs", "json", 120000);
  }

  getFeedbacksByObjectiveStats(
    courseId: string,
    objectiveId: string,
    params: QueryParams
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/learning-objectives/${objectiveId}/feedbacks/rates`;
    return api.get(url, params, "/graphs");
  }

  getFeedbacksByObjectiveStatsCsv(
    courseId: string,
    objectiveId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/statistics/courses/${courseId}/learning-objectives/${objectiveId}/feedbacks/rates/download`;
    return api.get(url, {}, "/graphs", "json", 120000);
  }

  getLogsByCourseId(courseId: string, params: QueryParams): Observable<any> {
    const url: string = `/userlog/course/${courseId}`;
    return api.get(url, params, "/log");
  }

  getLogsByCourseIdDownload(
    courseId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/userlog/course/${courseId}/download`;
    return api.get(url, {}, "/log", "json", 120000);
  }
  getLogsByCourseIdAndStudentId(
    courseId: string,
    studentId: string,
    params: QueryParams
  ): Observable<any> {
    const url: string = `/userlog/course/${courseId}/user/${studentId}`;
    return api.get(url, params, "/log");
  }

  getLogsByCourseIdAndStudentIdDownload(
    courseId: string,
    studentId: string,
    params: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/userlog/course/${courseId}/user/${studentId}/download`;
    return api.get(url, params, "/log", "json", 120000);
  }
}
